import Alert from "@/components/core/alert";
import { Button } from "@/components/core/buttons/button";
import { Form } from "@/components/core/forms/form.tsx";
import { FormControl, FormDescription, FormField, FormGroup, FormItem, FormLabel, FormMessage } from "@/components/core/forms/form.tsx";
import TagsInput from "@/components/core/forms/tags-input";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import type { CaseActivityShareSchema } from "@/features/case-record/types/case-records";
import userService from "@/features/dashboard/api/services/user-service";
import { useForm } from "react-hook-form";
import { useCaseActivityShareMutation } from "../api/queries/acitivities-query";
import type { CaseActivity } from "../types/activities";

export default function CaseActivityShareModal({ activity, branchId }: { activity: CaseActivity; branchId: string }) {
	const { closeModal } = useModalControl();
	const caseActivityShareMutation = useCaseActivityShareMutation();
	const form = useForm({
		defaultValues: {
			id: activity.id,
			share_with:
				activity.shared_with?.map((user) => ({
					label: `${user.full_name} (${user.email})`,
					value: user.user_id,
				})) || [],
		},
	});

	const handleSubmit = async (values: CaseActivityShareSchema) => {
		await caseActivityShareMutation.mutateAsync(values);
		closeModal();
	};

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(handleSubmit)}>
				<div className="flex flex-col w-full col-span-12">
					<FormField
						control={form.control}
						name="share_with"
						render={({ field }) => (
							<FormItem>
								<div className="flex flex-col w-full">
									<FormLabel required>Users</FormLabel>
									<FormDescription />
								</div>
								<FormGroup>
									<FormControl>
										<TagsInput
											isMulti={true}
											defaultValue={field.value}
											onValueChange={(value) => {
												field.onChange(value);
											}}
											loadOptions={async (value: string) => {
												const items = await userService.listByBranch(branchId);
												return items?.map((item) => ({
													label: `${item.full_name} (${item.email})`,
													value: item.id,
												}));
											}}
										/>
									</FormControl>
								</FormGroup>
								<FormMessage />
							</FormItem>
						)}
					/>
				</div>
				<div className="flex flex-row w-full gap-2 mt-4">
					<Button
						className=""
						variant="ghost"
						type="button"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>
					<Button className="" variant="secondary">
						Confirm
					</Button>
				</div>
			</form>
		</Form>
	);
}
